import React, { Component } from 'react';
import $ from 'jquery';

class CfdiCreateModal extends Component {
    closeCfdi = async () => {
        $('#cfdiDocumentsModal').modal('hide');  
    }
    renderDocumentCfdi =() =>{
        return(
            <div>
                 <div style={{display: "inline-flex", important: true, paddingTop: 10, paddingBottom: 0}}>
                    <input className='form-control btn-outline-secondary dropdown-toggle listSerie hide-pc' style={{display: 'inline-flex'}} placeholder="Buscarr" autoComplete="off" id='searchDataTableCreate'
                        type='search' aria-controls='dataTableTimbra'/>
                    <div className=" col-md" style={{width: 350}}>
                        <button className="btn btn-active" data-toggle="tooltip" data-placement="top">
                            <i className="fas fa-search"></i>
                        </button>
                    </div>
                </div>
           
                <table className="display" style={{width: '100%', marginTop: 10, marginBottom: 40}}>
                    <thead className="table-header-yellow">
                    <tr>
                        <td>Número Interno</td>
                        <td>Descripción</td>
                        <td></td>    
                    </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{textAlign:"center"}}></td>     
                            <td style={{textAlign:"center"}}></td>     
                            <td style={{textAlign:"center"}}></td> 
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }
    render() {
        return (
            <div>
                <div className="modal fade bd-example-modal-lg bgtransparent" tabIndex="-1" role="dialog"  id="cfdiDocumentsModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                                <h4 className="modal-title" id="modal-basic-title ">Uso Principal</h4>
                                <button type="button" className="close" onClick={this.closeCfdi} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            
                            <div className="modal-body">    
                                {this.renderDocumentCfdi()}
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeCfdi}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>    
            </div>
        );
    }
}

export default CfdiCreateModal;